import { render, staticRenderFns } from "./AdditionalFieldsText.vue?vue&type=template&id=e4c2a2b0&scoped=true&lang=pug&"
import script from "./AdditionalFieldsText.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2a2b0",
  null
  
)

export default component.exports